import gql from 'graphql-tag';

export const configurations = gql`
  query configurations(
    $countryCode: String!
    $language: String!
    $context: String
  ) {
    configurations(
      countryCode: $countryCode
      language: $language
      context: $context
    ) {
      aemFormsHandlerConfig {
        frontend
      }
      aemFormsResources {
        frontend
      }
      pickMeUpFromHome {
        active
      }
      booking {
        bookingActive
        rescheduleActive
        trackingInfo {
          sendTrackingInfo
          trackingParameterKeyValueSplitter
          trackingParameterSplitter
        }
      }
      cancellationForm {
        frontend
      }
      calendar {
        initialUnavailableDays
        timePicker {
          dayTimePeriods {
            id
          }
        }
      }
      labels
      links
      oneDoc {
        active
      }
      dealerSearch {
        frontend
      }
      summary {
        frontend
      }
      contactForm {
        frontend
      }
      modelSeriesMapper {
        frontend
      }
      modelSelection {
        carbonFootprint {
          energyEfficiency {
            visible
          }
          co2EmissionAndFuelConsumption {
            visible
          }
        }
        frontend
      }
      footNotes {
        frontend
      }
      sharedNotifications {
        driverLicenseNotifications {
          active
          weight
        }
      }
    }
  }
`;

export const userTestDriveBookings = gql`
  query userTestDriveBookings(
    $vehicleTypes: Set
    $countryCode: String!
    $context: String!
    $language: String!
    $modelSeriesId: String!
  ) {
    userTestDriveBookings(
      vehicleTypes: $vehicleTypes
      countryCode: $countryCode
      context: $context
      language: $language
      modelSeriesId: $modelSeriesId
    ) {
      countryCode
      dealer {
        address {
          computedAddress
        }
        computedName
        contacts {
          email
          phone
        }
        id
      }
      id
      language
      schedule {
        pickUpDateStr
        pickUpDateTime
        returnDateStr
        returnDateTime
      }
      status
      vehicle {
        co2Emission {
          max
          min
          unit
        }
        energyEfficiencyClass {
          name
          value
        }
        engine {
          type
          powerInKw {
            value
            unit
          }
          powerInHp {
            value
            unit
          }
        }
        fuelConsumption {
          electric {
            max
            min
            unit
          }
          fossil {
            max
            min
            unit
          }
        }
        fuelType
        id
        images {
          defaultImage
          fallbackImages
        }
        baumuster
        classId
        bodyStyleId
        modelName
        modelSeriesId
        motorisationId
        name
        transmission
        vehicleTypes
      }
      onlineStoreDeeplink
      appointmentMessage
    }
  }
`;

export const testDriveBookingsTimeslots = gql`
  query testDriveBookingsTimeslots(
    $dealerId: String!
    $countryCode: String!
    $context: String
    $language: String!
    $vehicleId: String!
    $day: LocalDate!
  ) {
    testDriveBookingsTimeslots(
      dealerId: $dealerId
      countryCode: $countryCode
      context: $context
      language: $language
      vehicleId: $vehicleId
      day: $day
    ) {
      duration {
        hours
        minutes
      }
      timeSlotInterval {
        end
        start
      }
    }
  }
`;

export const testDriveRequestsCalendar = gql`
  query testDriveRequestCalendar(
    $endDate: LocalDate!
    $dealerId: String!
    $countryCode: String!
    $context: String
    $language: String!
    $startDate: LocalDate!
  ) {
    testDriveRequestsCalendar(
      endDate: $endDate
      dealerId: $dealerId
      countryCode: $countryCode
      context: $context
      language: $language
      startDate: $startDate
    ) {
      available
      date
      dealerOpen
      requestTimeSlots {
        available
        end
        periodId
        start
      }
    }
  }
`;

export const testDriveBookingsCalendar = gql`
  query testDriveBookingsCalendar(
    $endDate: LocalDate!
    $dealerId: String!
    $countryCode: String!
    $context: String
    $language: String!
    $vehicleId: String!
    $startDate: LocalDate!
  ) {
    testDriveBookingsCalendar(
      endDate: $endDate
      dealerId: $dealerId
      countryCode: $countryCode
      context: $context
      language: $language
      vehicleId: $vehicleId
      startDate: $startDate
    ) {
      available
      date
      dealerOpen
    }
  }
`;

export const userTestDriveRequests = gql`
  query userTestDriveRequests(
    $vehicleTypes: Set
    $countryCode: String!
    $context: String!
    $language: String!
    $modelSeriesId: String!
  ) {
    userTestDriveRequests(
      vehicleTypes: $vehicleTypes
      countryCode: $countryCode
      context: $context
      language: $language
      modelSeriesId: $modelSeriesId
    ) {
      countryCode
      dealer {
        address {
          computedAddress
        }
        computedName
        contacts {
          email
          phone
        }
        id
      }
      id
      language
      status
      model {
        id
        images {
          defaultImage
          fallbackImages
        }
        className
        name
      }
      schedule {
        dayPeriod
        pickUpDateTime
      }
      transmission
      fuelType
      appointmentMessage
      motorisation {
        co2Emission {
          max
          min
          unit
        }
        energyEfficiencyClass
        fuelConsumption {
          electric {
            max
            min
            unit
          }
          fossil {
            max
            min
            unit
          }
        }
      }
    }
  }
`;

export const specificModel = gql`
  query specificModel(
    $countryCode: String!
    $language: String!
    $modelSeriesId: String!
    $vehicleTypes: Set
    $context: String
    $archivedMotorisations: Boolean
  ) {
    specificModel(
      countryCode: $countryCode
      language: $language
      modelSeriesId: $modelSeriesId
      vehicleTypes: $vehicleTypes
      context: $context
      archivedMotorisations: $archivedMotorisations
    ) {
      id
      name
      classId
      className
      bodyStyleId
      bodyStyleName
      weightCategories
      categories
      images {
        defaultImage
        fallbackImages
      }
      group
      vehicleTypeOptions
      fuelTypes
      transmissions
      motorisations {
        modelSeriesId
        vehicleTypes
        driveType
        lifeCycle
        wheelBase {
          id
          name
        }
        weight {
          maximum
        }
        engine {
          type
          powerInKw {
            value
            unit
          }
          powerInHp {
            value
            unit
          }
        }
        baumuster
        id
        name
        transmissions
        fuelType
        energyEfficiencyClass
        weightCategory
        co2Emission {
          min
          max
          unit
          individual
        }
        fuelConsumption {
          fossil {
            min
            max
            unit
            individual
          }
          electric {
            min
            max
            unit
            individual
          }
        }
        images {
          defaultImage
          fallbackImages
        }
      }
    }
  }
`;

export const dealers = gql`
  query dealers(
    $countryCode: String!
    $id: String!
    $language: String!
    $context: String
  ) {
    dealers(
      countryCode: $countryCode
      id: $id
      language: $language
      context: $context
    ) {
      computedName
      address {
        computedAddress
      }
      booking
      companyId
      id
      contacts {
        email
        phone
      }
    }
  }
`;

export const addressSuggestion = gql`
  query suggestions($countryCode: String!, $address: String!, $market: String) {
    suggestions(countryCode: $countryCode, address: $address, market: $market) {
      label
      locationId
      postalCode
    }
  }
`;

export const testDriveBookingVehicleSearchWithinRadius = gql`
  query testDriveBookingVehicleSearchWithinRadius(
    $endDate: LocalDate!
    $vehicleTypes: Set
    $countryCode: String!
    $context: String
    $market: String
    $language: String!
    $startDate: LocalDate!
    $modelSeriesId: String!
    $locationId: String
    $locationQuery: String
    $radius: String
    $searchProfileName: String
    $pickMeUp: Boolean
  ) {
    testDriveBookingVehicleSearchWithinRadius(
      endDate: $endDate
      vehicleTypes: $vehicleTypes
      countryCode: $countryCode
      context: $context
      language: $language
      startDate: $startDate
      modelSeriesId: $modelSeriesId
      locationId: $locationId
      locationQuery: $locationQuery
      radius: $radius
      searchProfileName: $searchProfileName
      pickMeUp: $pickMeUp
      market: $market
    ) {
      bookings {
        booking
        modelName
        name
        id
        dealerId
        motorisationId
        weightCategory
        minimumDriverAge
        baumuster
        timePeriodAvailability {
          morning
          afternoon
          evening
        }
        images {
          defaultImage
          fallbackImages
        }
        engine {
          type
          powerInKw {
            value
            unit
          }
          powerInHp {
            value
            unit
          }
        }
        fuelType
        transmission
        energyEfficiencyClass {
          name
          value
        }
        co2Emission {
          max
          min
          unit
          individual
        }
        fuelConsumption {
          fossil {
            min
            max
            unit
            individual
          }
          electric {
            min
            max
            unit
            individual
          }
        }
      }
      dealers {
        id
        computedName
        companyId
        address {
          computedAddress
          distance
          unit
        }
        contacts {
          email
          phone
        }
      }
    }
  }
`;

export const testDriveBookingVehicleSearch = gql`
  query testDriveBookingVehicleSearchFixedDealer(
    $endDate: LocalDate!
    $vehicleTypes: Set
    $countryCode: String!
    $context: String
    $language: String!
    $startDate: LocalDate!
    $modelSeriesId: String!
    $dealerId: String!
    $searchProfileName: String
    $pickMeUp: Boolean
  ) {
    testDriveBookingVehicleSearchFixedDealer(
      endDate: $endDate
      vehicleTypes: $vehicleTypes
      countryCode: $countryCode
      context: $context
      language: $language
      startDate: $startDate
      modelSeriesId: $modelSeriesId
      dealerId: $dealerId
      searchProfileName: $searchProfileName
      pickMeUp: $pickMeUp
    ) {
      bookings {
        booking
        modelName
        name
        id
        dealerId
        motorisationId
        weightCategory
        minimumDriverAge
        baumuster
        timePeriodAvailability {
          morning
          afternoon
          evening
        }
        images {
          defaultImage
          fallbackImages
        }
        engine {
          type
          powerInKw {
            value
            unit
          }
          powerInHp {
            value
            unit
          }
        }
        fuelType
        transmission
        energyEfficiencyClass {
          name
          value
        }
        co2Emission {
          max
          min
          unit
          individual
        }
        fuelConsumption {
          fossil {
            min
            max
            unit
            individual
          }
          electric {
            min
            max
            unit
            individual
          }
        }
      }
    }
  }
`;

export const dealerSearch = gql`
  query dealerSearch(
    $locationId: String!
    $countryCode: String!
    $language: String!
    $radius: String
    $searchProfileName: String
    $pickMeUp: Boolean
  ) {
    dealerSearch(
      locationId: $locationId
      countryCode: $countryCode
      language: $language
      radius: $radius
      searchProfileName: $searchProfileName
      pickMeUp: $pickMeUp
    ) {
      total
      dealers {
        id
      }
    }
  }
`;

export const users = gql`
  query users($token: String!) {
    users(token: $token) {
      ciamUid
    }
  }
`;

export const usersEmail = gql`
  query usersEmail($email: String!) {
    usersEmail(email: $email) {
      userId
    }
  }
`;
